<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">ইউনিয়ন ব্যবস্থাপনা</h1>
        <p class="page-subtitle">সকল ইউনিয়নের তালিকা দেখুন এবং স্ট্যাটাস পরিচালনা করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" class="btn-secondary-modern" (click)="refreshList()">
          <i class="fas fa-sync-alt"></i>
          রিফ্রেশ
        </button>
        <button type="button" class="btn-primary-modern" (click)="clearFilters()">
          <i class="fas fa-filter"></i>
          ফিল্টার সাফ করুন
        </button>
      </div>
    </div>
  </div>

  <!-- Filters and Actions Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-filter"></i>
        ফিল্টার এবং অ্যাকশন
      </h3>
    </div>
    
    <div class="card-body">
      <!-- Filter Controls -->
      <div class="filters-section">
        <div class="filter-row">
          <div class="filter-group">
            <label class="filter-label bangla-label">পৃষ্ঠা সাইজ:</label>
            <select class="form-control-modern" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
              <option *ngFor="let size of pageSizeOptions" [value]="size">
                {{ size }} টি
              </option>
            </select>
          </div>
          
          <div class="filter-group">
            <label class="filter-label bangla-label">স্ট্যাটাস ফিল্টার:</label>
            <select class="form-control-modern" [(ngModel)]="statusFilter" (change)="onStatusFilterChange()">
              <option value="">সব স্ট্যাটাস</option>
              <option value="active">সক্রিয়</option>
              <option value="suspended">স্থগিত</option>
              <option value="maintenance">রক্ষণাবেক্ষণ</option>
            </select>
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">অনুসন্ধান:</label>
            <input 
              type="text" 
              placeholder="ইউনিয়ন নাম, উপজেলা, জেলা বা সাবডোমেইন..." 
              class="form-control-modern" 
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              maxlength="100"
            >
          </div>

          <div class="filter-group">
            <button class="btn-outline-modern" (click)="clearFilters()">
              <i class="fas fa-times"></i>
              ফিল্টার সাফ করুন
            </button>
          </div>
        </div>
      </div>

      <!-- Current Status Info -->
      <div class="tab-status-info">
        <div class="status-badge">
          <i class="fas fa-info-circle"></i>
          <strong>ইউনিয়ন তালিকা</strong> - {{ totalCount }} টি রেকর্ড
          <span *ngIf="searchTerm" class="search-indicator">
            | অনুসন্ধান: "{{ searchTerm }}"
          </span>
          <span *ngIf="statusFilter" class="search-indicator">
            | স্ট্যাটাস: {{ getStatusFilterText() }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Data Table Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <div class="card-header-content">
        <div class="card-title-section">
          <h3 class="card-title bangla-title">
            <i class="fas fa-building"></i>
            ইউনিয়ন ডেটা
          </h3>
          <div class="card-actions">
            <span class="data-count">
              মোট <strong>{{totalCount}}</strong> টি ইউনিয়ন
            </span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && (!unions || unions.length === 0)" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-building"></i>
        </div>
        <h3 class="bangla-title">কোন ইউনিয়ন রেকর্ড পাওয়া যায়নি</h3>
        <p class="bangla-text">আপনার ফিল্টার অনুযায়ী কোন ইউনিয়ন নেই অথবা কোন ডেটা পাওয়া যায়নি।</p>
        <button type="button" (click)="clearFilters()" class="btn-primary-modern">
          <i class="fas fa-refresh"></i>
          ফিল্টার রিসেট করুন
        </button>
      </div>

      <!-- Data Table -->
      <div *ngIf="!isLoading && unions && unions.length > 0" class="table-responsive">
        <table class="table-modern" role="table" aria-label="ইউনিয়ন তালিকা">
          <thead>
            <tr role="row">
              <th class="actions-column" role="columnheader">অ্যাকশন</th>
              <th class="sortable-header" (click)="onSort('union_name')" 
                  role="columnheader" 
                  [attr.aria-sort]="sortBy === 'union_name' ? (sortOrder === 'ASC' ? 'ascending' : 'descending') : 'none'"
                  tabindex="0"
                  (keydown.enter)="onSort('union_name')"
                  (keydown.space)="onSort('union_name')"
                  [attr.aria-label]="'ইউনিয়ন নাম কলাম, ' + (sortBy === 'union_name' ? (sortOrder === 'ASC' ? 'ক্রমবর্ধমান' : 'ক্রমহ্রাসমান') + ' সাজানো' : 'সাজানো যাবে')">
                <span class="bangla-label">ইউনিয়ন নাম</span>
                <i *ngIf="sortBy === 'union_name'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="sortOrder === 'ASC'"
                   [class.fa-sort-down]="sortOrder === 'DESC'">
                </i>
              </th>
              <th class="sortable-header" (click)="onSort('upozilla_name')">
                <span class="bangla-label">উপজেলা</span>
                <i *ngIf="sortBy === 'upozilla_name'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="sortOrder === 'ASC'"
                   [class.fa-sort-down]="sortOrder === 'DESC'">
                </i>
              </th>
              <th class="sortable-header" (click)="onSort('zilla_name')">
                <span class="bangla-label">জেলা</span>
                <i *ngIf="sortBy === 'zilla_name'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="sortOrder === 'ASC'"
                   [class.fa-sort-down]="sortOrder === 'DESC'">
                </i>
              </th>
              <th>
                <span class="bangla-label">সাবডোমেইন</span>
              </th>
              <th class="sortable-header" (click)="onSort('status')">
                <span class="bangla-label">স্ট্যাটাস</span>
                <i *ngIf="sortBy === 'status'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="sortOrder === 'ASC'"
                   [class.fa-sort-down]="sortOrder === 'DESC'">
                </i>
              </th>
              <th>
                <span class="bangla-label">শেষ পরিবর্তন</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let union of unions; let i = index; trackBy: trackByUnionId" [class.table-striped]="i % 2 === 0">
              <td class="actions-cell">
                <div class="action-buttons-cell">
                  <button
                    title="স্ট্যাটাস পরিবর্তন"
                    class="btn-action-sm"
                    (click)="openStatusModal(union)"
                    [attr.aria-label]="'স্ট্যাটাস পরিবর্তন ' + union.union_name + ' এর জন্য'"
                  >
                    <i class="fas fa-power-off" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td>
                <div class="union-info">
                  <h4 class="union-name bangla-text">{{ union.union_name }}</h4>
                  <small class="union-id">ID: {{ union.id }}</small>
                </div>
              </td>
              <td class="bangla-text">{{ union.upozilla_name }}</td>
              <td class="bangla-text">{{ union.zilla_name }}</td>
              <td>
                <div class="subdomain-info">
                  <code class="subdomain-code">{{ union.subdomain }}</code>
                  <a [href]="'https://' + union.subdomain + '.nouftaxaday.com'" 
                     target="_blank" 
                     class="subdomain-link"
                     title="ইউনিয়ন সাইট দেখুন">
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </td>
              <td>
                <div class="status-cell">
                  <span [class]="getStatusBadgeClass(union)" class="status-badge-modern">
                    {{ getStatusText(union.status) }}
                  </span>
                  <div class="status-details" *ngIf="union.status !== 'active'">
                    <small class="status-time bangla-text" *ngIf="union.suspended_at">
                      {{ formatDate(union.suspended_at) }}
                    </small>
                    <small class="status-reason bangla-text" *ngIf="union.suspension_reason">
                      কারণ: {{ union.suspension_reason }}
                    </small>
                    <small class="status-by bangla-text" *ngIf="union.suspended_by_user">
                      পরিবর্তনকারী: {{ union.suspended_by_user.username }}
                    </small>
                  </div>
                </div>
              </td>
              <td class="bangla-text">
                {{ union.updatedAt ? (union.updatedAt | date:'dd/MM/yyyy') : 'N/A' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Info -->
      <div class="pagination-info">
        <span class="info-badge">
          {{ pageSize.toString() === 'All' ? 'সব ' + totalCount + ' টি আইটেম দেখানো হচ্ছে' : 
            'দেখানো হচ্ছে ' + ((currentPage - 1) * (+pageSize) + 1) + ' - ' +
            (currentPage * (+pageSize) > totalCount ? totalCount : currentPage * (+pageSize)) +
            ' এর মধ্যে ' + totalCount + ' টি' }}
        </span>
      </div>

      <!-- Pagination Controls -->
      <nav *ngIf="pageSize.toString() !== 'All' && totalPages > 1" class="pagination-nav">
        <div class="pagination-modern">
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="onPageChange(1)">
            <i class="fas fa-angle-double-left"></i>
            প্রথম
          </button>
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
            <i class="fas fa-angle-left"></i>
            পূর্ববর্তী
          </button>
          
          <div class="page-numbers">
            <button
              class="page-number"
              *ngFor="let page of getPaginationNumbers()"
              [class.active]="page === currentPage"
              [disabled]="page === -1"
              (click)="page !== -1 && onPageChange(page)"
            >
              {{ page === -1 ? '...' : page }}
            </button>
          </div>
          
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
            পরবর্তী
            <i class="fas fa-angle-right"></i>
          </button>
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(totalPages)">
            শেষ
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </nav>
    </div>
  </div>
</div>

<!-- Status Change Modal -->
<div class="modal fade" [class.show]="showStatusModal" [style.display]="showStatusModal ? 'block' : 'none'" 
     id="statusModal" tabindex="-1" aria-labelledby="statusModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-modern">
      <div class="modal-header">
        <h5 class="modal-title bangla-title" id="statusModalLabel">
          <i class="fas fa-power-off mr-2"></i>ইউনিয়ন স্ট্যাটাস পরিবর্তন
        </h5>
        <button type="button" class="btn-close" (click)="closeStatusModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body" *ngIf="selectedUnion">
        <!-- Union Info -->
        <div class="alert alert-info-modern">
          <i class="fas fa-info-circle"></i>
          <div class="alert-content">
            <strong>{{ selectedUnion.union_name }}</strong><br>
            <small>{{ selectedUnion.upozilla_name }}, {{ selectedUnion.zilla_name }}</small><br>
            <small>সাবডোমেইন: {{ selectedUnion.subdomain }}</small>
          </div>
        </div>

        <div class="union-current-status">
          <p class="status-info">
            <strong>বর্তমান স্ট্যাটাস:</strong>
            <span [class]="getStatusBadgeClass(selectedUnion)" class="status-badge-modern ml-2">
              {{ getStatusText(selectedUnion.status) }}
            </span>
          </p>
        </div>

        <form [formGroup]="statusChangeForm" class="status-form">
          <div class="form-group-modern">
            <label class="bangla-label required">নতুন স্ট্যাটাস:</label>
            <select class="form-control-modern" formControlName="newStatus">
              <option value="" disabled>স্ট্যাটাস নির্বাচন করুন</option>
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="statusChangeForm.get('newStatus')?.invalid && statusChangeForm.get('newStatus')?.touched">
              নতুন স্ট্যাটাস নির্বাচন করুন
            </div>
          </div>

          <div class="form-group-modern">
            <label class="bangla-label">কারণ:</label>
            <textarea
              class="form-control-modern"
              formControlName="reason"
              rows="3"
              placeholder="স্ট্যাটাস পরিবর্তনের কারণ লিখুন..."
              maxlength="500"></textarea>
            <small class="form-text text-muted bangla-text">
              ঐচ্ছিক - স্ট্যাটাস পরিবর্তনের কারণ উল্লেখ করুন
            </small>
          </div>

          <div class="form-group-modern">
            <label class="bangla-label">অতিরিক্ত মন্তব্য:</label>
            <textarea
              class="form-control-modern"
              formControlName="notes"
              rows="2"
              placeholder="অতিরিক্ত মন্তব্য..."
              maxlength="1000"></textarea>
          </div>
        </form>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn-outline-modern" (click)="closeStatusModal()" [disabled]="isSubmittingStatus">
          <i class="fas fa-times"></i>
          বাতিল
        </button>
        <button type="button" class="btn-primary-modern" (click)="submitStatusChange()"
                [disabled]="statusChangeForm.invalid || isSubmittingStatus">
          <i class="fas fa-spinner fa-spin" *ngIf="isSubmittingStatus"></i>
          <i class="fas fa-check" *ngIf="!isSubmittingStatus"></i>
          {{ isSubmittingStatus ? 'পরিবর্তন হচ্ছে...' : 'নিশ্চিত করুন' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showStatusModal" 
     [style.display]="showStatusModal ? 'block' : 'none'"></div>